<template>
  <div class="successPop" v-show="show">
    <img src="@assets/img/common/ok.svg" alt="ok">
    <p>{{successPop.msg}}</p>
    <p class="msg">{{successPop.tip}}</p>
  </div>
</template>

<script>
export default {
  name: 'equipmentLoan',
  data() {
    return {
      show: false,
      time: 3*1000,
      successPop: {
        msg: '',
        tip: ''
      }
    }
  },
  methods: {
    open(d) {
      this.time = d.time || this.time
      this.successPop = {
        msg: d.msg || '',
        tip: d.tip || ''
      }
      this.show = true
      this.close()
    },
    close() {
      setTimeout(() => {
        this.show = false
        this.successPop = {
          msg: '',
          tip: ''
        }
        
        window.close()
      }, this.time)
    }
  }
}
</script>

<style lang="less" scoped>
@import '../assets/css/global.less';

.successPop {
    width: 200px;
    height: 150px;
    background-color: rgba(0, 15, 15, .8);
    border-radius: 8px;
    overflow: hidden;
    position: fixed;
    z-index: 1200;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    margin: auto;
    padding: 24px 10px;
    img {
      width: 30px;
      height: 30px;
      margin: 0 auto;
      display: block;
    }
    p {
      font-size: 16px;
      color: #fff;
      text-align: center;
      margin-top: 14px;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      overflow: hidden;
    }
    .msg {
      margin-top: 4px;
      font-size: 12px;
    }
  }
</style>
